<main class="main">
    <div class="main-wrapper">
        <section class="padding-first about1" id="about_us">
        <div class="container">

	        <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
	            <div class="icon-back">
	                <span>Back</span>
	            </div>
	        </a>


	        <div>
	          	<div class="bl-rows">
		            <div class="text">

                        <h2>🚀 **Exciting Announcement for the Mexican Market!** 🌟</h2>

		                <span>By Gennius Aug 7, 2023</span>
		            </div>
		            <div class="img">
		                <img src="./assets/img/gennius/bg-inside-notice6.webp">
		            </div>
	          	</div>
	        </div>

	          	<div class="bl-center">

                    <p>I am thrilled to share some incredible news with all of you! 🌟</p>

		            <p>We are delighted to announce the appointment of <strong>Francisco Delgado</strong> as Partner for the business development of <strong>“My Rewards – Visa Loyalty Solution”</strong> in the <strong>Mexican market</strong>. 🎉</p>

                    <p>Francisco comes with an extensive background in the financial services industry, leadership in payment technology
                    companies, and most importantly, the visionary mindset required to execute a successful strategy for <strong>Gennius</strong> clients’ in
                    Mexico. 🌐 Based in Mexico City, Francisco is a well-known figure within the financial services ecosystem.</p>

                    <p>Mexico holds tremendous significance for Visa, <strong>Gennius</strong>, and our remarkable <strong>My Rewards program</strong>, boasting over 100+
                    potential clients. This marks the beginning of a new chapter as we set out to serve this market with a personalized and
                    unparalleled approach, delivering value to our cherished banking, merchant, and Web3 partners. 💼</p>

					<p>At <strong>Gennius XYZ</strong>, we pride ourselves on being a long-term partner of Visa in many fronts, including loyalty, virtual
                    cards, Cybersource processing, #VisaDirect, and more. As the operators of <strong>My Rewards - Visa Loyalty Solution</strong>, a
                    whitelabel #superapp for Financial Institutions and Merchants, we are committed to elevating #digitalbanking engagement
                    with consumers through #loyalty and #rewards.</p>

                    <p>As we embark on this exciting journey with Francisco, allow me to share some of the unparalleled value propositions that
                    <strong>My Rewards</strong> offers:</p>

                    <p>🎁 **Experience seamless #loyaltyrewards checkout:** Choose from a variety of rewarding options, including Miles, Miles
                    & Card, and Only-Card, to ensure a delightful user experience.</p>

                    <p>💳 **A powerful digital #wallet facilitating effortless inbound/outbound #paymentsinnovation and redemptions:**
                    Streamline your payment processes and enjoy the convenience of redeeming rewards hassle-free.</p>

                    <p>📞 **Enjoy round-the-clock bot+human support for uninterrupted assistance:** Our dedicated support team is always ready
                    to assist you, ensuring a smooth and satisfying experience.</p>

                    <p>🏢 **Establish your brand identity with custom-branded #web and #app stores:** Personalize your loyalty program to
                    reflect your brand's unique identity and strengthen customer loyalty.</p>

                    <p>🎯 **Optimize customer #lifecyclemanagement through our #digitalmarketing expertise, leaving no stone unturned!**
                    Maximize the potential of your loyalty program with our expert digital marketing strategies.</p>

                    <p>I invite you all to join me in celebrating this milestone and experiencing the exceptional benefits of <strong>My Rewards</strong>.
                    Together, let's shape a brighter and more rewarding future for Mexican consumers!</p>

	          	</div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
